
<app-nav></app-nav>
<div class="thank-you">
    <div class="right-icon"></div>
    <h3>Thank You</h3>
    <h5>We will call you back within 24 hours.</h5>
</div>
